/* eslint-disable */ 
import React from 'react';
import { Form } from 'formik';

import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { CANDIDATE_AVAILABILITIES, CANDIDATE_SALARY_CURRENCIES } from 'constants/currenciesConstant';
import { COUNTRY_OF_TAX_OTHER, SUPPORTED_COUNTRIES_LIST } from 'constants/candidateConstants';

const CandidateJourneyPreferencesFormView = ({
    setFieldValue,
    handleSubmit,
    handleChange,
    errors,
    touched,
    values,
    countries,
    handleBlur,
    setIsUnsupportedLocationDialogOpen,
    setValues,
}) => {
    const otherCountriesList = countries?.filter((country) => !SUPPORTED_COUNTRIES_LIST.includes(country.name)).map((country) => country.name);

    return (
        <Form>
            <div className="form-row">
                <Typography className="subheading-xl color-grey form-sub-title">Which country are you a tax resident of?</Typography>

                <Autocomplete
                    name="countryOfTax"
                    value={values.countryOfTax}
                    options={[...SUPPORTED_COUNTRIES_LIST, COUNTRY_OF_TAX_OTHER]}
                    autoHighlight
                    getOptionLabel={(option) => option}
                    renderOption={(option) => <span>{option}</span>}
                    onChange={(event, newValue) => {
                        if (newValue === COUNTRY_OF_TAX_OTHER) {
                            setIsUnsupportedLocationDialogOpen(true);
                        }
                        setFieldValue('countryOfTax', newValue);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            className={`${touched.countryOfTax && errors.countryOfTax ? "with-error" : "base-input"}`}
                            value={values.countryOfTax}
                            onBlur={handleBlur}
                            label="Choose Country"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            variant="outlined"
                            inputProps={{
                                ...params.inputProps,
                            }}
                            error={touched.countryOfTax && Boolean(errors.countryOfTax)}
                            helperText={touched.countryOfTax && errors.countryOfTax}
                        />
                    )}
                />
            </div>

            {values.countryOfTax === COUNTRY_OF_TAX_OTHER &&
                <div className="form-row">
                    <Autocomplete
                        name="otherCountryOfTax"
                        value={values.otherCountryOfTax}
                        options={otherCountriesList}
                        autoHighlight
                        getOptionLabel={(option) => option}
                        renderOption={(option) => <span>{option}</span>}
                        onChange={(event, newValue) => {
                            setFieldValue('otherCountryOfTax', newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className={`${touched.otherCountryOfTax && errors.otherCountryOfTax ? "with-error" : "base-input"}`}
                                value={values.otherCountryOfTax}
                                onBlur={handleBlur}
                                label="Other Country"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                variant="outlined"
                                inputProps={{
                                    ...params.inputProps,
                                }}
                                error={touched.otherCountryOfTax && Boolean(errors.otherCountryOfTax)}
                                helperText={touched.otherCountryOfTax && errors.otherCountryOfTax}
                            />
                        )}
                    />
                </div>
            }

            <div className="form-row">
                <Typography className="subheading-xl color-grey form-sub-title">
                    What is your desired monthly net salary (after tax and social security)?
                </Typography>

                <div className="form-cols">
                    <div className="col-1of2">
                        <TextField
                            className={`${touched.netSalaryValue && errors.netSalaryValue ? "with-error" : "base-input"}`}
                            type="number"
                            variant="outlined"
                            label="Enter Value"
                            InputLabelProps={{ shrink: true }}
                            value={values.netSalaryValue}
                            name="netSalaryValue"
                            fullWidth={true}
                            onChange={(event) => {
                                setFieldValue('netSalaryValue', Number(event.target.value));
                            }}
                            error={touched.netSalaryValue && Boolean(errors.netSalaryValue)}
                            helperText={touched.netSalaryValue && errors.netSalaryValue}
                        />
                    </div>

                    <div className="col-1of2">
                        <TextField
                            className={`${touched.salaryCurrency && errors.salaryCurrency ? "with-error" : "base-input"}`}
                            select
                            label="Choose Currency"
                            InputLabelProps={{ shrink: true }}
                            value={values.salaryCurrency}
                            variant="outlined"
                            onChange={handleChange}
                            name="salaryCurrency"
                            id="salaryCurrency"
                            fullWidth={true}
                            error={touched.salaryCurrency && Boolean(errors.salaryCurrency)}
                            helperText={touched.salaryCurrency && errors.salaryCurrency}
                        >
                            {CANDIDATE_SALARY_CURRENCIES.map((currency) => {
                                return (
                                    <MenuItem key={currency.VALUE} value={currency.LABEL}>
                                        {currency.LABEL}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </div>
                </div>
            </div>

            <div className="form-row">
                <Typography className="subheading-xl color-grey form-sub-title">When is the earliest you can start a new project?</Typography>

                <div className="col-1of2 candidate-earliestDate">
                    <TextField
                        className={`${touched.earliestDate && errors.earliestDate ? "with-error" : "base-input"}`}
                        select
                        label="Select"
                        InputLabelProps={{ shrink: true }}
                        name="earliestDate"
                        id="earliestDate"
                        variant="outlined"
                        value={values.earliestDate}
                        onChange={handleChange}
                        fullWidth
                        error={touched.earliestDate && Boolean(errors.earliestDate)}
                        helperText={touched.earliestDate && errors.earliestDate}
                    >
                        {CANDIDATE_AVAILABILITIES.map((availability) => {
                            return (
                                <MenuItem key={availability.VALUE} value={availability.LABEL}>
                                    {availability.LABEL}
                                </MenuItem>
                            );
                        })}
                    </TextField>
                </div>
            </div>
        </Form>
    );
};

export default CandidateJourneyPreferencesFormView;
